import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IInterval } from '../company-call-history-filters.model';

@Component({
  selector: 'filter-interval',
  templateUrl: './filter-interval.component.html',
  styleUrls: ['./filter-interval.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterIntervalComponent),
      multi: true
    }
  ]
})
export class FilterIntervalComponent implements ControlValueAccessor {

  @Input() unit: string;

  public value: IInterval = {
    from: null,
    to: null
  };
  public onChange: any = () => { };
  public onTouch: any = () => { };

  constructor() {}

  ngOnInit() {
  }

  public onChangeFromValue(event: InputEvent) {
    this.value.from = Number(event.target['value']);
    if(Number.isNaN(this.value.from) ){
      this.onChange(null);
    } else {
      this.onChange(this.value);
    }
  }

  public onChangeToValue(event: InputEvent) {
    this.value.to = Number(event.target['value']);
    if(Number.isNaN(this.value.to) || this.value.to === 0 ){
      this.onChange(null);
    } else {
      this.onChange(this.value);
    }
  }

  writeValue(obj: IInterval): void {
    if (obj) {
      this.value = {...obj};
      if(this.unit === 'minutes') {
        this.value.from /= 60;
        this.value.to /= 60;
      }
      this.onChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    //this is running after writeValue
    //so we need to call it with the current value
    if(this.value) this.onChange(this.value);
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}
